
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Failed","transform":"translate(-1553.211 -1039.211)"}},[_c('g',{attrs:{"id":"Ellipse_140","data-name":"Ellipse 140","transform":"translate(1553.211 1039.211)","fill":"none","stroke":"#e95d65","stroke-width":"1"}},[_c('circle',{attrs:{"cx":"12","cy":"12","r":"12","stroke":"none"}}),_c('circle',{attrs:{"cx":"12","cy":"12","r":"11.5"}})]),_c('path',{attrs:{"id":"Path_19240","data-name":"Path 19240","d":"M679.583 389.941l1.76-1.759a.9.9 0 00-1.27-1.27l-1.759 1.76-1.76-1.76a.9.9 0 00-1.27 1.27l1.76 1.759-1.76 1.76a.9.9 0 001.27 1.27l1.76-1.76 1.759 1.76a.9.9 0 101.27-1.27z","transform":"translate(886.894 661.27)","fill":"#e95d65"}})])])
          )
        }
      }
    